module.exports = __webpack_public_path__ + "media/images/common/logo_bg_02-4ce831d78dede9675e86118713f294a6.png";